// DD-3641: the backend's stored usage figures (usage collection read side).
// The value is stored in bytes for the storage metric; the page converts to GB.

export const STORAGE_BYTES_METRIC = 'STORAGE_BYTES';

export type UsageRow = {
    dimension: string | null;
    value: number;
    unit: string;
    calculatedAt: number | null;
};

export type OrganizationUsage = {
    metric: string;
    rows: UsageRow[];
    totalValue: number;
    lastCalculatedAt: number | null;
};
